<template>
  <div class="spineAnimal">
    <breadcrumb class="bread" :path="path" :name="name" :childPath="childPath" :childName="childName"
                :childPathThree="childPathThree" :childNameThree="childNameThree"></breadcrumb>
    <div class="main-row contain">
      <div class="col col-xlg-12 col-sm-12 spineAnimal-item">
        <div class="searchStyle">
        <el-form :inline="true" :model="searchForm" label-position="top">
          <el-form-item label="科中文名" prop="sectionChinese">
            <el-input v-model="searchForm.sectionChinese" placeholder="科中文名"/>
          </el-form-item>
          <el-form-item label="科拉丁名" prop="sectionLatin">
            <el-input v-model="searchForm.sectionLatin" placeholder="科拉丁名"/>
          </el-form-item>
          <el-form-item label="物种查询" prop="speciesQuery">
            <el-input v-model="searchForm.speciesQuery" placeholder="科中文名或科拉丁名"/>
          </el-form-item>
          <el-form-item label="DNA条形码片段" prop="stripFragmentList">
            <el-select multiple v-model="searchForm.stripFragmentList" clearable placeholder="请选择DNA条形码片段">
              <el-option :label="item" :value="item" v-for="(item, index) in stripFragmentOP" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <div style="display: inline-block" class="button">
            <el-button type="primary" @click="onSubmit">查询</el-button>
            <el-button type="primary" @click="backSubmit">返回</el-button>
          </div>
        </el-form>
        </div>
        <template >
          <el-table border :data="tableData" style="width: 100%"  :row-style="{height: '8px'}"
                    :cell-style="{padding:'0px'}" :header-cell-style="{backgroundColor: '#eee',color: '#333'}">
            <el-table-column type="index" header-align="center" align="left" label="序号" width="80">
              <template slot-scope="scope">
                <span>{{ (page - 1) * pageSize + scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="sectionChinese" header-align="center" align="left" label="科中文名" width="" show-overflow-tooltip/>
            <el-table-column prop="sectionLatin" header-align="center" align="left" label="科拉丁名" width="" show-overflow-tooltip/>
            <el-table-column prop="chineseName" header-align="center" align="left" label="物种中文名" width="" show-overflow-tooltip/>
            <el-table-column prop="scientificName" header-align="center" align="left" label="物种学名" width="" show-overflow-tooltip/>
            <el-table-column prop="collectNumber" header-align="center" align="left" label="采集号" width="" show-overflow-tooltip/>
            <el-table-column prop="libNum" header-align="center" align="left" label="库号" width="" show-overflow-tooltip/>
            <el-table-column prop="collectUser" header-align="center" align="left" label="采集人" width="" show-overflow-tooltip/>
            <el-table-column prop="collectTime" header-align="center" align="left" label="采集日期" width="" show-overflow-tooltip value-format="yyyy-MM-dd" />
            <el-table-column prop="province" header-align="center" align="left" label="省" width="" show-overflow-tooltip/>
            <el-table-column prop="area" header-align="center" align="left" label="地区" width="" show-overflow-tooltip/>
            <el-table-column prop="stripFragment" header-align="center" align="left" label="DNA条形码片段" width="" show-overflow-tooltip/>
            <el-table-column label="操作" header-align="center" align="left" fixed="right" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="toTableDetail(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagin"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="page"
                         :page-size="pageSize"
                         :page-sizes="[25,50,75,100]"
                         layout="total,sizes, prev, pager, next"
                         :total="totalPage">
          </el-pagination>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb'
import { fetchList, getStripFragmentList } from '@/network/dnaBar/spineAnimal'
export default {
  name: "spineAnimal",
  components: { breadcrumb },
  data() {
    return {
      type: 'dnaBarZoo',
    path: '',
    name: '',
      childName:'',
      childPath:'',
      childPathThree: '',
      childNameThree: '',
      page: 1,
      pageSize: 25,
      totalPage: 0,
      tableData: [],
      searchForm: {},
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.path = from.path
      vm.name = '资源'

    })
  },
  mounted() {
    this.getList ()
    this.$nextTick(() => {

    })
  },

  created() {
    this.childPathThree=this.$route.path
    this.childNameThree = this.$route.name
    this.childName = '动物DNA条形码'
    this.childPath = this.$route.path
  //   console.log(this.$route.path,this.$route.name,this.$route.params)
    this.getSelectData()
  },
  methods: {
    getSelectData() {
      getStripFragmentList().then(res => {
        // console.log(res)
        this.stripFragmentOP = res.data.data
      })
    },
    getList() {
      fetchList(Object.assign({
        page: this.page,
        pageSize: this.pageSize,
        // type: this.type
      }, this.searchForm)).then(response => {
        this.tableData = response.data.data.dnaBarZooList
        this.totalPage = response.data.data.total
      })
    },
    handleSizeChange(val){
      this.pageSize = val
      this.page = 1
      this.getList()

    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    toTableDetail(row) {
      this.$router.push({
        path: '/tableDetail',
        query: {
          id: row.id,
          formName: this.type,
          name: '脊椎动物'
        }
      })
    },
    onSubmit() {
      this.page = 1
      this.getList()
    },
    backSubmit() {
      this.page = 1
      this.searchForm = {}
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/spineAnimal";
::v-deep .el-pagination {
  padding: 20px 5px !important;
  text-align: center;
}
</style>